<script>import Avatar from "../elements/Avatar.svelte";
import { formatDateDistance } from "../../utils/date";
export let title = null;
export let text = null;
export let avatarUrl = null;
export let initials = null;
export let name = null;
export let job = null;
export let classNames = null;
export let singleQuote = false;
export let date = null;
</script>

<div class={classNames}>
  {#if title}
    <p class="font-bold {singleQuote ? 'text-center text-2xl' : 'text-lg'}">{title}</p>
  {/if}
  <div class={singleQuote ? 'text-lg text-center' : ''}>
    "{text}"
  </div>
  {#if name || job || date}
    <div class="space-x-3 pt-4 flex items-center {singleQuote ? 'justify-center text-lg' : ''}">
      {#if name}
        <Avatar imageUrl={avatarUrl} {initials} alt={name} />
        <span>
          <strong>{name}</strong>
          {#if job}
            <span class="text-primary font-bold"> / </span>
            <span>{job}</span>
          {/if}
          {#if date}
            <span class="font-light">{formatDateDistance(date)}</span>
          {/if}
        </span>
      {/if}
    </div>
  {/if}
</div>
